import { render, staticRenderFns } from "./DocumentNumberTemplateForm.vue?vue&type=template&id=196acb4e&scoped=true&"
import script from "./DocumentNumberTemplateForm.vue?vue&type=script&lang=js&"
export * from "./DocumentNumberTemplateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "196acb4e",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VForm } from 'vuetify/lib/components/VForm';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VForm,VSelect,VSpacer,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/srv/dev/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('196acb4e')) {
      api.createRecord('196acb4e', component.options)
    } else {
      api.reload('196acb4e', component.options)
    }
    module.hot.accept("./DocumentNumberTemplateForm.vue?vue&type=template&id=196acb4e&scoped=true&", function () {
      api.rerender('196acb4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Settings/DocumentNumberTemplateForm.vue"
export default component.exports